import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../../../../../../VentoryUI/components/common/Modal/DeleteModal';
import { useRequest } from '../../../../../../../../requests/common/requestHook';
import { translate } from '../../../../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../../../../types/translation/TranslationKey';
import { Routing } from '../../../../../../../../util/routes.util';
import { ProductMasterDataExportConfigurationRequest } from '../../../../../../../../requests/productMasterDataExportConfiguration.request';
import { ProductMasterDataExportConfigurationContext } from '../../../../../../../../context/ProductMasterDataExportConfigurationContext';
import {
  DeleteProductMasterDataExportConfigurationInput,
  ProductMasterDataExportConfigurationInput,
} from '../../../../../../../../types/product_master_data_export_configuration';

interface DeleteProductMasterDataExportConfigurationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  ids: Set<string>;
}

export default function DeleteProductMasterDataExportConfigurationModal({
  open,
  setOpen,
  ids,
}: DeleteProductMasterDataExportConfigurationModalProps) {
  const navigate = useNavigate();

  const { productMasterDataExportConfigurations, setProductMasterDataExportConfigurations } = useContext(
    ProductMasterDataExportConfigurationContext,
  );

  const [remove, { loading }] = useRequest(ProductMasterDataExportConfigurationRequest.remove);

  const handleDelete = async () => {
    const toDelete: DeleteProductMasterDataExportConfigurationInput[] = [];
    for (const id of ids) {
      const config = productMasterDataExportConfigurations.get(id);
      if (config) toDelete.push(new ProductMasterDataExportConfigurationInput(config).forDelete());
    }

    const result = await remove({ data: toDelete });
    if (!result) return;

    for (const config of result) {
      productMasterDataExportConfigurations.delete(config.id);
    }
    setProductMasterDataExportConfigurations(new Map(productMasterDataExportConfigurations));
    handleClose();
    navigate(Routing.productMasterData.settings.report.overview());
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DeleteModal
      text={translate({ key: TranslationKey.productMasterDataExportConfigurationDeleteConfirmationText })}
      onConfirm={handleDelete}
      open={open}
      onClose={handleClose}
      loading={loading}
    />
  );
}
